import React from 'react';
import PropTypes from 'prop-types';
import { UncontrolledTooltip } from 'reactstrap';
import { Button } from 'react-bootstrap';
import { dateToString } from '../../common/utils/date/Date.utils';
import { preparePriceFormat } from '../../helpers/preparePriceFormat';
import editIcon from '../../assets/img/icons/edit-primary.svg';

function DashboardTableRow({ item, isDashboardAccount }) {
  const {
    id,
    serial,
    registrationPlate,
    vehicleMakeName,
    vehicleModelName,
    vehicleDerivative,
    vehicleYear,
    locationCity,
    soldOn,
    salePriceInPence,
    sellerOrganizationName,
    buyerOrganizationName,
  } = item;

  const rowTitle = `${vehicleMakeName} ${vehicleModelName} ${vehicleDerivative} | ${vehicleYear} | ${locationCity}`;

  return (
    <>
      <td>{serial}</td>
      <td>{registrationPlate}</td>
      <td>{rowTitle}</td>
      <td>{dateToString(soldOn)}</td>
      <td>{salePriceInPence ? preparePriceFormat(salePriceInPence, true) : '-'}</td>
      <td>{sellerOrganizationName}</td>
      <td>{buyerOrganizationName}</td>
      {!isDashboardAccount && (
        <td className="text-right">
          <Button
            className="btn-icon rounded-circle btn-ghost-light"
            id={`tooltip_edit${id}`}
            size="sm"
            type="button"
          >
            <img src={editIcon} alt="Edit icon" />
          </Button>
          <UncontrolledTooltip
            delay={0}
            className="uncontrolled-tooltip"
            target={`tooltip_edit${id}`}
          >
            Edit
          </UncontrolledTooltip>
        </td>
      )}
    </>
  );
}

export default DashboardTableRow;

DashboardTableRow.propTypes = {
  item: PropTypes.object.isRequired,
  isDashboardAccount: PropTypes.bool.isRequired,
};
